import { render, staticRenderFns } from "./AdService.vue?vue&type=template&id=4507185e&lang=pug"
import script from "./AdService.vue?vue&type=script&lang=js"
export * from "./AdService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports